var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-filter-form',{attrs:{"filter":_vm.filterForm,"fields":_vm.allFields,"default-common-fields":_vm.defaultCommonFields,"default-more-fields":_vm.defaultMoreFields,"config-key":"problemFilterConfig"},on:{"change":_vm.handleFieldChange,"search":_vm.handleSearch,"reset":_vm.handleReset},scopedSlots:_vm._u([{key:"field",fn:function({ field, form, reset, labelCol, wrapperCol }){return [_c('problem-filter-form-item',{attrs:{"form":form,"field":field,"options":{
        statusList: _vm.problemStatus,
        channels: _vm.problemChannels,
        urgencys: _vm.problemUrgencys,
        projectOptions: _vm.projectOptions
      },"search-data":{
        story: {
          searching: _vm.storySearching,
          data: _vm.searchStoryData
        }
      },"reset":reset,"label-col":labelCol,"wrapper-col":wrapperCol},on:{"change":_vm.handleFieldChange,"search":_vm.handleFieldSearch}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }